import React, { useEffect, useState } from "react"
import AIEmailGate from "./AIEmailGate"
import AIChatWindow from "./AIChatWindow"
import AICallWindow from "./AICallWindow"
import "../styles/ai-try.scss"

// In-page overlay that hosts the gate / chat / call views.
// `view` is one of: "gate" | "chat" | "call". The carousel owns orchestration.
const AITryModal = ({ open, view, name, heading, onClose, onVerified }) => {
  const [mounted, setMounted] = useState(false)
  useEffect(() => setMounted(true), [])

  useEffect(() => {
    if (!open) return undefined
    const onKey = e => {
      if (e.key === "Escape") onClose()
    }
    document.addEventListener("keydown", onKey)
    return () => document.removeEventListener("keydown", onKey)
  }, [open, onClose])

  if (!mounted || !open) return null

  const title =
    view === "chat" ? "Chat with AI" : view === "call" ? "Voice Call" : "Try our AI agents"

  return (
    <div className="aitry-overlay" onClick={onClose} role="presentation">
      <div
        className={`aitry-modal aitry-modal--${view}`}
        onClick={e => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={title}
      >
        {view === "gate" ? (
          <button
            type="button"
            className="aitry-modal__close aitry-modal__close--float"
            onClick={onClose}
            aria-label="Close"
          >
            &times;
          </button>
        ) : (
          <div className="aitry-modal__header">
            <div>
              <span className="aitry-modal__title">{title}</span>
              {heading && <span className="aitry-modal__subtitle">{heading}</span>}
            </div>
            <button type="button" className="aitry-modal__close" onClick={onClose} aria-label="Close">
              &times;
            </button>
          </div>
        )}
        <div className="aitry-modal__body">
          {view === "gate" && <AIEmailGate onVerified={onVerified} />}
          {view === "chat" && <AIChatWindow name={name} onClose={onClose} />}
          {view === "call" && <AICallWindow name={name} onClose={onClose} />}
        </div>
      </div>
    </div>
  )
}

export default AITryModal
